export const partners = [
    "asurion",
    "verizon",
    "att",
    "tmobile",
    "cricket",
    "adt",
    "amazonrouter",
    "hpsales",
    "microsoft",
];
export const lobs = ["soluto", "mobility", "care"];
